import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal-info-conjuge-avalista',
  templateUrl: './modal-info-conjuge-avalista.component.html',
  styleUrls: ['./modal-info-conjuge-avalista.component.scss']
})
export class ModalInfoConjugeAvalistaComponent {

  constructor(
    private modalInstance: BsModalRef,
  ) { }

  close() {
    this.modalInstance.hide();
  }

}
